import { DynamicDropdown, StaticDropdown } from "src/Components";
import UsersDropdown from "src/Components/Dropdown/Users/UsersDropdown";
import { ICCOrderSearchParams } from "src/Interfaces/ccOrder";
import { deltaHedgeOrderTypesDropdownOptions } from "src/Pages/DeltaHedgeOrder/DeltaHedgeOrder";
import { getCCOrderUsers } from "src/Requests/ccOrder";
import { getRiskProfileDropDown } from "src/Requests/coveredCall";
import { getStepInstruments } from "src/Requests/stepRequests";

interface IProps {
  onChange: (name: string, value: any) => void;
  searchParam: ICCOrderSearchParams;
}

const SearchParamBox = ({ onChange, searchParam }: IProps) => {
  return (
    <div className="w-full flex flex-row  justify-start items-center gap-2">
      <div className="w-48">
        <StaticDropdown
          dropdown={{
            name: "coveredCallOrderType",
            placeholder: "فرایند",
          }}
          onChange={(n, v) => onChange(n, v ? Number(v) : undefined)}
          options={deltaHedgeOrderTypesDropdownOptions}
          value={searchParam.coveredCallOrderType?.toString()}
        />
      </div>
      <div className="w-48">
        <DynamicDropdown
          dropdown={{
            name: "instrumentId",
            placeholder: "نماد",
          }}
          onChange={onChange}
          getData={getStepInstruments}
          value={searchParam.instrumentId}
        />
      </div>
      <div className="w-48">
        <DynamicDropdown
          dropdown={{
            name: "profileId",
            placeholder: "ریسک پروفایل",
          }}
          onChange={onChange}
          getData={getRiskProfileDropDown}
          value={searchParam.profileId}
        />
      </div>

      <div className="w-48">
        <UsersDropdown
          label="اکانت"
          name="accountId"
          value={searchParam.accountId}
          onChange={onChange}
          getData={getCCOrderUsers}
        />
      </div>
    </div>
  );
};

export default SearchParamBox;
